import {
  GET_CALENDAR_EVENTS_SUCCESS,
  GET_CALENDAR_EVENT_FEATURE,
  GET_CALENDAR_EVENT_FEATURE_SUCCESS,
  GET_CALENDAR_REPORTS_SUCCESS,
  RESET_CALENDAR_EVENT_FEATURE,
  RESET_CALENDAR_REPORTS,
} from "./actionTypes"

const INIT_STATE = {
  calendarEvents: [],
  calendarEventFeature: null,
  calendarReports: null,
  loading: false,
}

const CalendarEvents = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CALENDAR_EVENTS_SUCCESS:
      return {
        ...state,
        calendarEvents: action.payload,
      }
    case GET_CALENDAR_EVENT_FEATURE:
      return {
        ...state,
        loading: true,
      }
    case GET_CALENDAR_EVENT_FEATURE_SUCCESS:
      return {
        ...state,
        calendarEventFeature: action.payload,
        loading: false,
      }
    case RESET_CALENDAR_EVENT_FEATURE:
      return {
        ...state,
        calendarEventFeature: null,
      }
    case GET_CALENDAR_REPORTS_SUCCESS:
      return {
        ...state,
        calendarReports: action.payload,
      }
    case RESET_CALENDAR_REPORTS:
      return {
        ...state,
        calendarReports: null,
      }
    default:
      return state
  }
}

export default CalendarEvents
